import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { InputNumber } from 'primeng/inputnumber';
import { TipoFormula } from '../models';
import { Constantes } from '../models/constantes';
import { DetalleFormula } from '../models/detalleformula';
import { Formula } from '../models/formula';
import { FormulaColor } from '../models/formulacolor';
import { Medida } from '../models/medida';
import { FormulaService } from '../services';
import { NextcloudService } from '../services/nextcloud.service';

@Component({
  selector: 'formula-child',
  templateUrl: './formula-child.component.html',
  styleUrls: ['./formula-child.component.scss']
})
export class FormulaChildComponent implements OnInit {

  // @Input() formulaChild: Formula;
  @Input() tipo: TipoFormula;
  @Input() formulaColor: FormulaColor;
  medidas: Medida[];
  medida: Medida;
  cantidad: number;

  noDisponible: boolean;


  blocked: boolean = false;
  @ViewChild('inputCantidad') inputCantidad: InputNumber;
  @ViewChild('mapContainer') mapContainer!: ElementRef<HTMLElement>;

  private _formulaChild: Formula;

  @Input()
  set formulaChild(value: Formula) {
    this._formulaChild = value;
    this.calculos();

  }

  get formulaChild(): Formula {
    return this._formulaChild;
  }

  detaRueda: DetalleFormula[];
  detaEjeSuperior: DetalleFormula[];
  detaEjeInferior: DetalleFormula[];
  detaEfecto: DetalleFormula[];

  ejeSuperior: number = 50;
  ejeInferior: number = 400;
  ejeX: number = 60;
  efectosX: number = 700;
  efectosY: number = 350;

  hoverCardVisible: boolean = false;
  hoverCardX: number = 0;
  hoverCardY: number = 0;
  hoverCardCodigo: string = '';
  hoverCardDescripcionHtml: SafeHtml | '' = '';
  hoverCardObservacion: string = '';
  hoverCardTinteNombre: string = '';
  hoverCardTinteCodigo: string = '';
  hoverCardImagenSrc: string = '';
  private hoverHideTimer: any = null;
  private lastHoverCodigo: string | null = null;

  constructor(
    private formulaService: FormulaService,
    private nextcloudService: NextcloudService,
    private sanitizer: DomSanitizer
  ) { }

  private sanitizedHtml(valor: string | null | undefined): SafeHtml | '' {
    const html = String(valor ?? '').trim();
    if (!html) {
      return '';
    }

    const limpio = html
      .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
      .replace(/<iframe[\s\S]*?>[\s\S]*?<\/iframe>/gi, '')
      .replace(/<object[\s\S]*?>[\s\S]*?<\/object>/gi, '')
      .replace(/<embed[\s\S]*?>[\s\S]*?<\/embed>/gi, '')
      .replace(/\son\w+\s*=\s*"[^"]*"/gi, '')
      .replace(/\son\w+\s*=\s*'[^']*'/gi, '')
      .replace(/\son\w+\s*=\s*[^\s>]+/gi, '')
      .replace(/\s(href|src)\s*=\s*"\s*javascript:[^"]*"/gi, ' $1="#"')
      .replace(/\s(href|src)\s*=\s*'\s*javascript:[^']*'/gi, " $1='#'");

    return this.sanitizer.bypassSecurityTrustHtml(limpio);
  }

  onTinteHoverEnter(event: MouseEvent, deta: DetalleFormula): void {
    this.cancelHoverHide();
    this.updateHoverPosition(event);

    const pictograma = deta?.tinte?.pictograma;
    const codigoActual = deta?.tinte?.pk?.codigo || null;

    this.hoverCardTinteNombre = deta?.tinte?.nombre || '';
    this.hoverCardCodigo = pictograma?.idPictograma || 'Sin pictograma';
    this.hoverCardDescripcionHtml = this.sanitizedHtml(pictograma?.descripcion || '');
    this.hoverCardObservacion = pictograma?.observacion || '';
    this.hoverCardTinteCodigo = codigoActual || '';

    const mustReloadImage = this.lastHoverCodigo !== codigoActual;
    this.lastHoverCodigo = codigoActual;
    if (mustReloadImage) {
      this.hoverCardImagenSrc = '';
    }

    this.hoverCardVisible = true;

    if (mustReloadImage && pictograma?.urlImage) {
      this.nextcloudService.getImagenComoBase64(pictograma.urlImage).subscribe(src => {
        this.hoverCardImagenSrc = src;
      });
    }
  }

  onTinteHoverMove(event: MouseEvent): void {
    if (!this.hoverCardVisible) {
      return;
    }

    this.updateHoverPosition(event);
  }

  onTinteHoverLeave(): void {
    this.scheduleHoverHide();
  }

  onHoverCardEnter(): void {
    this.cancelHoverHide();
  }

  onHoverCardLeave(): void {
    this.scheduleHoverHide();
  }

  private updateHoverPosition(event: MouseEvent): void {
    const container = this.mapContainer?.nativeElement;
    if (!container) {
      this.hoverCardX = event.clientX;
      this.hoverCardY = event.clientY;
      return;
    }

    const rect = container.getBoundingClientRect();
    const rawX = event.clientX - rect.left + 2;
    const rawY = event.clientY - rect.top - 2;

    // Keep tooltip-card inside map container bounds.
    const cardWidth = 430;
    const cardHeight = 210;
    const maxX = Math.max(8, rect.width - cardWidth - 8);
    const maxY = Math.max(8, rect.height - cardHeight - 8);

    this.hoverCardX = Math.min(Math.max(8, rawX), maxX);
    this.hoverCardY = Math.min(Math.max(8, rawY), maxY);
  }

  private scheduleHoverHide(): void {
    this.cancelHoverHide();
    this.hoverHideTimer = setTimeout(() => {
      this.hoverCardVisible = false;
      this.lastHoverCodigo = null;
    }, 140);
  }

  private cancelHoverHide(): void {
    if (this.hoverHideTimer) {
      clearTimeout(this.hoverHideTimer);
      this.hoverHideTimer = null;
    }
  }

  buildPictogramaTooltip(deta: DetalleFormula): string {
    const pictograma = deta?.tinte?.pictograma;
    if (!pictograma) {
      return `Tinte: ${deta?.tinte?.pk?.codigo || ''} | Sin pictograma asociado`;
    }

    const codigo = pictograma.idPictograma ? `Codigo: ${pictograma.idPictograma}` : '';
    const descripcion = pictograma.descripcion ? `Descripcion: ${pictograma.descripcion}` : '';
    const observacion = pictograma.observacion ? `Observacion: ${pictograma.observacion}` : '';

    return [codigo, descripcion, observacion].filter(Boolean).join(' | ');
  }


  ngOnInit(): void {

    this.getMedidas();
  }

  calculos(): void {

    //this sets all product descriptions to a max length of 10 characters
    this.formulaChild.detalle.forEach((deta) => {
      if (!deta.tinte.activo) {
        this.noDisponible = true;
      }
    });

    this.detaRueda = this.formulaChild.detalle.filter(x => x.tinte.ubicacion === 'Rueda');
    this.detaEjeSuperior = this.formulaChild.detalle.filter(x => x.tinte.ubicacion === 'Eje Superior');
    this.detaEjeInferior = this.formulaChild.detalle.filter(x => x.tinte.ubicacion === 'Eje Inferior');
    this.detaEfecto = this.formulaChild.detalle.filter(x => x.tinte.ubicacion === 'Efecto');


    // Ordenar por cantidad de ingrediente descendente
    this.sortDetalle();



  }


  sortDetalle() {

    if (this.formulaChild.pk.idsistema == 1) {
      this.formulaChild.detalle.sort(this.compareDescendente);
    } else {
      this.formulaChild.detalle.sort(this.comparadorUltra);
    }

  }

  compareDescendente(a: DetalleFormula, b: DetalleFormula) {
    if (a.cantidad < b.cantidad) {
      return 1;
    }
    if (a.cantidad > b.cantidad) {
      return -1;
    }
    return 0;
  }

  comparadorUltra(a: DetalleFormula, b: DetalleFormula): number {
    if (a.tinte.pk.codigo === "U7209" || a.tinte.pk.codigo === "U7215") {
      // Tintes con códigos "U7209" o "U7215" al inicio
      return -1;
    } else if (b.tinte.pk.codigo === "U7209" || b.tinte.pk.codigo === "U7215") {
      return 1;
    } else if (a.tinte.pk.codigo.startsWith("PT") && b.tinte.pk.codigo.startsWith("PT")) {
      // Tintes que inician con "PT"
      return b.cantidad - a.cantidad;
    } else if (a.tinte.pk.codigo.startsWith("U7") && b.tinte.pk.codigo.startsWith("U7")) {
      // Tintes que inician con "U7"
      return b.cantidad - a.cantidad;
    } else if (a.tinte.pk.codigo.startsWith("PT")) {
      return -1;
    } else if (b.tinte.pk.codigo.startsWith("PT")) {
      return 1;
    } else {
      // Ordenar por cantidad en orden descendente
      return b.cantidad - a.cantidad;
    }
    
  }


  getMedidas(): void {
    this.formulaService.getAllMedidas()
      .subscribe(meds => {
        this.medidas = meds;
        this.formulaService.getMedidaById(Constantes.ONZA).subscribe(
          med => {
            this.cantidad = 1;
            this.medida = med;
          }
        )
      });
  }

  get sumaTinte() {
    return this.formulaChild.detalle
      .reduce((sum: number, b: DetalleFormula) => sum + b.cantidad, 0);
  }


  convertir() {
    //this.formulaService.getConversion(this.formulaChild.id, this.medida, this.cantidad)

    if (this.blocked) {
      return;
    }

    this.blocked = true;

    this.formulaService.getConversion(this.formulaChild.pk.idsistema, this.formulaChild.pk.id,
      this.formulaColor?.pk.idcolor, this.medida, this.cantidad)
      .subscribe(details => {
        this.formulaChild.detalle = details;
        this.sortDetalle();
        this.inputCantidad.input.nativeElement.focus();
        this.blocked = false;
      }, error => {
        this.blocked = false;
        this.inputCantidad.input.nativeElement.focus();
      });
  }

  display: boolean = false;

  showDialog() {
    this.display = true;
  }


}
